import React, { useEffect, useState } from 'react'
import { Box, Avatar, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Grid, makeStyles, Typography, withStyles, Divider } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete';
import CustomInput from '../../../../../Components/CustomInput';
import MaterialTable from 'material-table';
import EditIcon from '@material-ui/icons/Edit';
import DataService from '../../../../../Service';
import CircularIndeterminate from '../../../../../Components/Loader';
import { ObjectToFormdata } from '../../../../../Common/Utils/common_utils';

function EditSetup(props) {
    const { openDialogFlag, parentDialogEvent, currentData, afterEdit } = props;
    console.log(`openDialogFlag`, currentData)
    const [open, setOpen] = useState(openDialogFlag);
    const [userData, setUserData] = useState({});
    const [maxWidth, setMaxWidth] = useState('sm');

    useEffect(() => {
        setOpen(open);
        setUserData({ ...userData, "name": currentData.name })

    }, [open])

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        parentDialogEvent('')
    };

    const editCompetency = (event) => {
        // setLoading(true)
        var postData = { "id": currentData.id, "name": userData.name };

        DataService.updateData(ObjectToFormdata({ ...postData }), currentData.id, 'competencies')
            .then((res) => {
                console.log(`res`, res)
                afterEdit()
                handleClose()
            })
            .catch((err) => {
                // setLoading(false);
            });

    }

    const setInputState = (inputStateValue, inputId) => {
        console.log('inputStateValue, inputId', inputStateValue, inputId)
        setUserData({ ...userData, [inputId]: inputStateValue })
    }

    return <Box>
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} fullWidth="100%"
            maxWidth={maxWidth} style={{ padding: 24 }}>
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                <Box fontWeight="fontWeightBold">Edit New Competency</Box>
            </DialogTitle>
            <DialogContent dividers>
                <Box p={3}>
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={3}>
                            <Typography variant="h6">
                                <Box>Competency</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <CustomInput id="name" variant="outlined" placeholder="Enter Competency name" parentcall={setInputState} value={userData.name} />
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions>
                <Box px={3} py={2}>
                    <Button  disableElevation  variant="contained" onClick={handleClose}>Cancel</Button>
                    <Button  disableElevation  variant="contained" color="secondary" onClick={editCompetency} style={{ marginLeft: 10 }}>Update</Button>
                </Box>

            </DialogActions>
        </Dialog>
    </Box>

}

export default EditSetup


